import React, { useEffect, useState } from "react";
import Wrapper from "../components/Wrapper";
import Main from "../components/Main";
import Content from "../components/Content";
import Footer from "../components/Footer";
import { useAuth } from "../providers/authProvider";
import { authApi } from "../api/authServices";
import Loader from "../components/Loader";
import Sidebar from "../components/admin/sidebar/Sidebar";
import { Navigate } from "react-router-dom";
import { ACTIONS, useSidebar } from "../providers/sidebarProvider";

const Admin = ({ path, roles, children }) => {
  const [authContext, setAuthContext] = useAuth();
  const [, setSidebarContext] = useSidebar();

  const [redirectToLogin, setRedirectToLogin] = useState(false);
  const [loading, setLoading] = useState();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const result = await authApi.validate();
      if (!result) {
        setLoading(false);
        setRedirectToLogin(true);
      } else {
        setAuthContext({ currentUser: result });
        setLoading(false);
      }
    };
    if (!authContext.currentUser) {
      fetchData();
    }
  }, [authContext.currentUser, setAuthContext]);

  useEffect(() => {
    const dashboardRoutes = ["/sales-dashboard", "/dashboards"];
    if (dashboardRoutes.includes(path)) {
      setSidebarContext({
        action: ACTIONS.CLOSE,
      });
      setSidebarContext({
        action: ACTIONS.SET_HAMBURGER_VISIBLE,
        payload: { value: true },
      });
    } else {
      setSidebarContext({
        action: ACTIONS.OPEN,
      });
      setSidebarContext({
        action: ACTIONS.SET_HAMBURGER_VISIBLE,
        payload: { value: false },
      });
    }
  }, [path, setSidebarContext]);

  if (
    authContext.currentUser &&
    roles &&
    roles.indexOf(authContext.currentUser.userRoleId) < 0
  ) {
    return <Navigate to="/error/401" />;
  }

  return loading || !authContext.currentUser ? (
    <Loader />
  ) : redirectToLogin ? (
    <Navigate to={`/auth/sign-in`} />
  ) : (
    <React.Fragment>
      <Wrapper className="overflow-visible min-width-992px">
        <Sidebar />
        <Main className="d-flex flex-column justify-content-between">
          <Content>{children}</Content>
          <Footer />
        </Main>
      </Wrapper>
    </React.Fragment>
  );
};

export default Admin;
